import { createSlice } from '@reduxjs/toolkit';

const initialUserState = {
  username: "Guest",
  institution: "uknown",
  email: null,
  activated: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    setUserEmail(state, action) {
      state.email = action.payload;
    },
    setUserName(state, action) {
      state.username = action.payload;
    },
    setUserInstitution(state, action) {
      state.institution = action.payload;
    },
    setUserActivated(state, action) {
      state.activated = action.payload;
    }
  },
});

export const { setUserEmail, setUserName, setUserInstitution, setUserActivated } = userSlice.actions;
export default userSlice.reducer;
